<div>
    <h2 class="typography-title-l textPrimary mb-4 mt-0">{{title | translate}}</h2>
    <div *ngIf="shouldShowFilters" class="flex flex-wrap items-end gap-2 basis-full mb-4 md:mb-8 md:basis-0 lg:grid lg:grid-cols-4 lg:gap-6">
        <div class="flex-1 basis-full md:basis-0 lg:col-span-1">
            <div class="typography-body-m-medium mb-2">
                <label>
                    {{'application' | translate}}
                </label>
            </div>
            <app-select
                [small]="true"
                [placeholder]="'select' | translate"
                [options]="availableTypes"
                [selectedValue]="filteredApplication"
                [required]="false"
                [disabled]="false"
                [searchable]="true"
                (selectedValueChanged)="onApplicationFilter($event)"
            ></app-select>
        </div>
        <div class="flex-1 basis-full md:basis-0 lg:col-span-1">
            <div class="typography-body-m-medium mb-2">
                <label>
                    {{'brand' | translate}}
                </label>
            </div>
            <app-select
                [small]="true"
                [placeholder]="'select' | translate"
                [options]="availableBrands"
                [selectedValue]="filteredBrand"
                [required]="false"
                [disabled]="false"
                [searchable]="true"
                (selectedValueChanged)="onBrandFilter($event)"
            ></app-select>
        </div>
        <div class="hidden lg:block lg:col-span-1"></div>
        <div class="flex-1 basis-full mt-5 md:basis-0 md:mt-0 lg:col-span-1">

            <app-input
                (keyPressed)="filterSearch($event, true)"
                (valueChanged)="filterSearch($event, false)"
                [value]="search"
                placeholder="{{ 'global.search_input_placeholder' | translate }}"
                class="w-full"
                [block]=true
            />
        </div>
    </div>
    <ng-container *ngIf="currentPageFormations && currentPageFormations.length > 0">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-4">
            <div *ngFor="let formation of currentPageFormations">
                <app-c-academy-card [formation]="formation" (onUpdate)="onFormationUpdate()"></app-c-academy-card>
            </div>
        </div>
        <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (onPageChange)="onPageChange($event)"></app-pagination>
    </ng-container>
    <ng-container *ngIf="currentPageFormations && currentPageFormations.length === 0">
        <div class="bg-white flex h-[200px] justify-center items-center">
            <span class="typography-title-s">{{'cacademy.no_available_formations' | translate}}</span>
        </div>
    </ng-container>
</div>
